import { Outlet } from '@tanstack/react-router';
import { ThemeToggle } from '@opengoal/ui';

/**
 * Chrome for the signed-out screens (sign in, forgot/reset password, accept
 * invitation). Each page supplies its own layout via `AuthShell`, which fills
 * the viewport — so anything added here is positioned *over* it rather than
 * stacked after it, or it lands below the fold.
 *
 * Inline-start, not inline-end: AuthShell's dark panel occupies the inline-end
 * half on wide screens, and the toggle belongs over the form column.
 */
export function AuthLayout() {
  return (
    <div className="relative min-h-svh">
      <Outlet />
      <div className="absolute start-4 top-4 z-10">
        <ThemeToggle />
      </div>
    </div>
  );
}
